// Cookie-changing auth requests must finish in order. A late refresh/login must
// neither publish credentials nor overwrite the cookie after a newer login.
let generation = 0;
let tail: Promise<unknown> = Promise.resolve();

export const sessionGeneration = () => generation;
export const SESSION_TRANSITION_EVENT = 'vendoriq:session-transition';
export const beginSessionTransition = () => {
  ++generation;
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_TRANSITION_EVENT));
  return generation;
};
export const sessionIsCurrent = (owner: number) => owner === generation;

export function serializeSessionRequest<T>(owner: number, operation: () => Promise<T>): Promise<T> {
  const result = tail.catch(() => undefined).then(async () => {
    if (!sessionIsCurrent(owner)) throw new Error('session_replaced');
    const value = await operation();
    if (!sessionIsCurrent(owner)) throw new Error('session_replaced');
    return value;
  });
  tail = result.catch(() => undefined);
  return result;
}
